
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import LegalWrapper from "components/LegalWrapper";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = LegalWrapper
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Datenschutz`}</h1>
    <h2>{`Datenhosting / Sicherheit personenbezogener Daten`}</h2>
    <p>{`Wir stellen sicher, dass Daten in Rechenzentren gehostet werden, die internationalen IT-Standards und Regularien entsprechen. Die von unserem CRM genutzten Rechenzentren liegen in Europa.`}</p>
    <p>{`Jede Website-Version des CRM ist als Backed up verfügbar. Jede Softwareversion wird in GIT gespeichert und kann bei Bedarf abgerufen werden. Die Daten werden täglich in Google Cloud Storage (GCP Bucket) gespeichert und 30 Tage lang aufbewahrt. Die Daten werden an mehreren Serverstandorten in ganz Europa gespeichert, um Sicherheit und Verfügbarkeit zu gewährleisten.`}</p>
    <p>{`Kritische Systemaktualisierungen werden durch uns implementiert, sobald Informationen über nötige Aktualisierungen seitens der integrierten und verwendeten Systemdienstleister vorliegen.`}</p>
    <p>{`Die Daten des CRM werden auf der Google-Infrastruktur (Basismodul des CRM) verschlüsselt. Sie werden nur nach Genehmigung angezeigt. Zum Schutz der Daten auf dem Weg durch das Internet bei Lese- und Schreibvorgängen verwenden wir Transport Layer Security (HTTPS).`}</p>
    <p><a parentName="p" {...{
        "href": "https://cloud.google.com/security/encryption-at-rest"
      }}>{`https://cloud.google.com/security/encryption-at-rest`}</a></p>
    <h2>{`Verwendete Sub-Systeme / Drittanbieter:`}</h2>
    <p>{`Wir stellen über die Datensicherheits- und Datenschutzerklärung von Drittanbieter sicher, dass diese ebenfalls verantwortlich für den Schutz von personenbezogenen Daten sind und deren Sub-Systeme entsprechende datenschutzrechtliche Vorgaben erfüllen.`}</p>
    <p><strong parentName="p">{`Google Firebase und Google Cloud Platform: Basis – Plattform des CRM`}</strong></p>
    <p>{`Google Firebase Datenverarbeitung und Sicherheitsbedingungen:`}</p>
    <p><a parentName="p" {...{
        "href": "https://firebase.google.com/terms/data-processing-terms"
      }}>{`https://firebase.google.com/terms/data-processing-terms`}</a></p>
    <p>{`Google Cloud Security:`}</p>
    <p><a parentName="p" {...{
        "href": "https://cloud.google.com/security/encryption-at-rest"
      }}>{`https://cloud.google.com/security/encryption-at-rest`}</a></p>
    <p>{`Google Privacy Policy:`}</p>
    <p><a parentName="p" {...{
        "href": "https://policies.google.com/privacy?hl=de"
      }}>{`https://policies.google.com/privacy?hl=de`}</a></p>
    <p><strong parentName="p">{`ZEIT: Sub-System für Hosting`}</strong></p>
    <p>{`ZEIT Privacy Policy:`}</p>
    <p><a parentName="p" {...{
        "href": "https://zeit.co/legal/privacy-policy"
      }}>{`https://zeit.co/legal/privacy-policy`}</a></p>
    <p>{`ZEIT Data Processing Addendum:`}</p>
    <p><a parentName="p" {...{
        "href": "https://zeit.co/legal/dpa"
      }}>{`https://zeit.co/legal/dpa`}</a></p>
    <p><strong parentName="p">{`ELASTIC: Sub-System für Volltextsuche`}</strong></p>
    <p>{`ELASTIC Privacy Policy`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.elastic.co/de/legal/privacy-statement"
      }}>{`https://www.elastic.co/de/legal/privacy-statement`}</a></p>
    <p>{`ELASTIC Security and Compliance:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.elastic.co/de/security-and-compliance"
      }}>{`https://www.elastic.co/de/security-and-compliance`}</a></p>
    <p><strong parentName="p">{`SENTRY: Sub-System für Error Tracking`}</strong></p>
    <p>{`SENTRY Privacy Politcy:`}</p>
    <p><a parentName="p" {...{
        "href": "https://sentry.io/privacy/"
      }}>{`https://sentry.io/privacy/`}</a></p>
    <p>{`SENTRY Security and Compliance:`}</p>
    <p><a parentName="p" {...{
        "href": "https://sentry.io/security/"
      }}>{`https://sentry.io/security/`}</a></p>
    <h2>{`Kundendaten, Auftragsdaten, Ticketsystem etc.`}</h2>
    <p>{`Die Aktivitäten der Händler/Servicepartner werden durch das Ticketingsystem und die Ereignisprotokollierung protokolliert und überwacht, um die Bearbeitung der Kundentickets sicher zu stellen.`}</p>
    <h2>{`Info zu Google Analytics:`}</h2>
    <p>{`Die über die Website verfolgten Endbenutzerdaten werden durch Google Analytics anonymisiert. Andere Daten werden nicht für die Leistungsverfolgung / -verbesserung verwendet.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;